import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import Analytics from 'analytics-opencare';

import { useAnalyticsService } from 'services/AnalyticsService';

import { STEP_KEY, generateStepAnalytics } from '../../utils';
import {
  StepWrapper,
  ButtonBlock,
  SecondaryButton,
} from '../../styled-components';
import {
  Title,
  Subtitle,
  OptionBlock,
  PrimaryButton,
} from '../../../common/styled-components';
import Multiselect from '../../../common/components/MultiSelect/MultiSelect';
import { useFunnelStorage } from '../../storage/Storage';

import { options } from './constants';

const analytics = new Analytics();

const Availability = ({ position, moveToNextStep }) => {
  const storage = useFunnelStorage();

  const analyticsService = useAnalyticsService();

  const savedAvailability = storage.get(STEP_KEY.AVAILABILITY);
  const hasSavedAvailability = Array.isArray(savedAvailability);

  const [selectedAvailability, setSelectedAvailability] = useState(
    hasSavedAvailability ? savedAvailability : [],
  );

  useEffect(() => {
    analytics.trackPageView({
      pageType: analytics.pageTypes.FUNNEL,
      pageName: 'funnel_availability',
      ...generateStepAnalytics(position, storage),
      ...analyticsService.analyticsData,
    });
  }, []);

  const change = value => {
    const previouslySelected = selectedAvailability.find(
      time => time === value,
    );

    if (previouslySelected) {
      const newAvailability = selectedAvailability.filter(
        time => time !== value,
      );

      setSelectedAvailability(newAvailability);
    } else {
      setSelectedAvailability([...selectedAvailability, value]);
    }
  };

  const complete = e => {
    e.preventDefault();

    const indexes = selectedAvailability.map(
      saved => options.findIndex(option => option.title === saved) + 1,
    );

    analytics.trackClick({
      pageType: analytics.pageTypes.FUNNEL,
      pageName: 'funnel_availability',
      name: 'wizard',
      section: 'availability',
      position: indexes.length > 0 ? indexes : [options.length + 1],
      ...generateStepAnalytics(position, storage, {
        response:
          selectedAvailability.length > 0
            ? selectedAvailability.join(',')
            : 'No preference',
      }),
    });

    storage.save(STEP_KEY.AVAILABILITY, selectedAvailability, true);
    moveToNextStep();
  };

  return (
    <div>
      <Title id="title">When is the best time of day for your visit?</Title>
      <Subtitle>Choose all of the times that work for you.</Subtitle>
      <StepWrapper>
        <form onSubmit={complete}>
          <OptionBlock row={3}>
            {options.map(option => (
              <Multiselect
                key={option.id}
                id={option.id}
                name="availability"
                title={option.title}
                description={option.description}
                onChange={change}
                Icon={option.icon}
                initialSelected={
                  savedAvailability && savedAvailability.includes(option.title)
                }
              />
            ))}
          </OptionBlock>
          <ButtonBlock>
            {selectedAvailability.length === 0
              ?               (
                <SecondaryButton
                  data-testid="skip"
                  type="submit"
                  selected={
                    hasSavedAvailability && savedAvailability.length === 0
                  }
                >
                  No preference
                </SecondaryButton>
              )
              :               (
                <PrimaryButton data-testid="continue" type="submit">
                  Continue
                </PrimaryButton>
              )
            }
          </ButtonBlock>
        </form>
      </StepWrapper>
    </div>
  );
};

Availability.defaultProps = {
  position: '',
};

Availability.propTypes = {
  position: PropTypes.string,
  moveToNextStep: PropTypes.func.isRequired,
};

export default Availability;
